import CustomButton from "common/components/Button/Button"
import InputTags from "common/components/InputTags/InputTags"
import { isValidEmail } from "common/utils/formValidations"
import { catalogosSelector } from "features/Inventario/redux/selectors/catalogosSelector"
import { shareCatalogo } from "features/Inventario/redux/slices/catalogosSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useState } from "react"
import { useTranslation } from "react-i18next"

const ShareCatalogo = ({ catalogo, onHide }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [tags, setTags] = useState([])
  const [addTagTrigger, setAddTagTrigger] = useState(false)
  const { sharingCatalogo } = useSelector(catalogosSelector)

  const onAutoSend = (newTags = []) => {
    // @ts-expect-error TS(2339): Property 'text' does not exist on type 'never'.
    const emails = newTags.map((email) => email.text)
    dispatch(
      shareCatalogo({
        emails,
        catalogoId: catalogo.id,
      })
    )
    onHide()
  }

  return (
    <div>
      <p>
        {t("catalogos.compartir.headerText")}{" "}
        <span className='f-weight-500'>{catalogo?.nombre}</span>
      </p>

      <div>
        <label htmlFor='emails'>{t("catalogos.compartir.labelMail")}</label>
        <InputTags
          id='emails'
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onChange={() => {}}
          isValidTagFn={isValidEmail}
          placeholder={`${t("catalogos.compartir.placeholderMail")}`}
          errorMessage={`${t("catalogos.compartir.errorMsg")}`}
          tags={tags}
          setTags={setTags}
          addTagTrigger={addTagTrigger}
          setAddTagTrigger={setAddTagTrigger}
          autosend
          onAutoSend={onAutoSend}
        />
        <div className='mt-5 d-flex align-items-center justify-content-end'>
          <span
            className='link-cancel'
            onClick={onHide}
          >
            {t("catalogos.compartir.cancelButton")}
          </span>
          <CustomButton
            loading={sharingCatalogo}
            onClick={() => setAddTagTrigger(true)}
            className='tw-ml-4 !tw-bg-primary'
            label={`${t("catalogos.compartir.shareButton")}`}
          />
        </div>
      </div>
    </div>
  )
}

export default ShareCatalogo
